/**
 * Missions-app Supabase client
 *
 * Uses shared @cow/supabase-client package for consistent configuration
 * across the monorepo. Database types are defined below for TypeScript support.
 */
import { supabase as sharedSupabase } from '@/lib/supabase-client';
export const supabase = sharedSupabase;
export const supabaseClient = supabase;
